import React from 'react';
interface StickyButtonProps {
  targetRef: React.RefObject<HTMLElement>;
  onClick: () => void;
}
export const StickyButton: React.FC<StickyButtonProps> = ({
  onClick
}) => {
  // Get tomorrow's date and format it as "14 nov"
  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const day = tomorrow.getDate();
    const monthNames = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
    const month = monthNames[tomorrow.getMonth()];
    return `${day} ${month}`;
  };
  return <div className="fixed bottom-0 left-0 right-0 z-50 flex justify-center bg-white border-t border-gray-300 pointer-events-none" data-id="element-286">
      <div className="w-full max-w-2xl p-4 pointer-events-auto" data-id="element-287">
        <div className="text-center mb-2 text-sm text-gray-700 font-medium" data-id="element-288">
          Morgen {getTomorrowDate()} • 10:00, 13:00 of 20:00
        </div>
        <button onClick={onClick} className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-2xl shadow-lg transition-all duration-200 uppercase text-sm md:text-base" data-id="element-289">
          Aanmelden gratis webinar over hondencommunicatie
        </button>
      </div>
    </div>;
};